import React, { FC } from 'react'
import { useModal } from '@shared/lib'
import { useBreakpoint } from '@shared/lib/react'
import { TextButton } from '@shared/ui/atoms'
import NewAccountsIntructionModalDesktop from './NewAccountsIntructionModalDesktop'
import NewAccountsIntructionModalMobile from './NewAccountsIntructionModalMobile'

const NewAccountsIntructionButton: FC = () => {
  const { isModalActive, handleModalClose, handleModalOpen } = useModal()

  const { isMobile } = useBreakpoint()

  return (
    <>
      <TextButton onClick={handleModalOpen}>новых аккаунтов</TextButton>
      {isMobile ? (
        <NewAccountsIntructionModalMobile open={isModalActive} onClose={handleModalClose} />
      ) : (
        <NewAccountsIntructionModalDesktop open={isModalActive} onClose={handleModalClose} />
      )}
    </>
  )
}

export default NewAccountsIntructionButton
